import styled from 'styled-components'

import { CurrencyModel } from '@root/entities/currency'
import { WalletSelectItem } from '@root/entities/wallet/ui/desktop/wallet-select-item'
import { WalletShort } from '@root/entities/wallet/ui/wallet-short/wallet-short'
import { AmountFormatted } from '@root/shared/core/format'

import type { Size } from '@blade/ui-theme'
import type { ProfileWallet } from '@root/entities/profile/model/profile-wallet'
import type { ClassNameProps } from '@root/shared/react'

export type WalletSelectorItemProps = {
  active?: boolean
  wallet: ProfileWallet
  onClick?: React.MouseEventHandler<HTMLElement>
  size?: Extract<Size, 's' | 'm'>
} & ClassNameProps

export const WalletSelectorItem: React.FC<WalletSelectorItemProps> = ({
  active = false,
  wallet,
  onClick,
  size = 'm',
  className,
}) => {
  const nativeCurrency = CurrencyModel.nativeOf(wallet.network)

  return (
    <WalletSelectItem
      active={active}
      selectionMode={'radio'}
      onClick={onClick}
      balanceNativeSlot={
        <AmountFormatted
          amount={wallet.balance.native}
          currency={nativeCurrency.ticker}
          roundingMode="trunc"
        />
      }
      balanceUsd={wallet.balance.usd}
      address={wallet.address}
      walletNameSlot={<WalletName name={wallet.name} color={wallet.color} />}
      size={size}
      className={className}
    />
  )
}

const WalletName = styled(WalletShort)`
  gap: 2px;
  line-height: 1;

  [data-size='s'] & {
    --wallet-short-indicator-size: 3px;

    font-size: 12px;
    font-weight: 600;
  }
  [data-size='m'] & {
    --wallet-short-indicator-size: 4px;

    font-size: 12px;
    font-weight: 700;
  }
`
